import React from 'react';
import ProVerified from '@fiverr-private/pro_verified/src';
import SafePureComponent from '../shared/SafePureComponent';

import './style.scss';

const ProBox = () => (
    <ProVerified/>
);

export { ProBox };
export default SafePureComponent(ProBox);
